import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  loadingBox: {
    margin: "0 auto",
    textAlign: "center",
    padding: 30,
    color: "#FF2C46",
  },
  loadingTextMessage: {
    marginBottom: "16px",
  },
  loading: {
    textAlign: "center",
    margin: "0 auto",
    color: "#ff2c46",
  },
}));
